import React from 'react'
import styled from '@emotion/styled'
import { IconTooltip, palette, Theme } from '@yuno/design-system-web'

type StyledProps = { theme?: Theme }

export type ConnectionItemProps = {
  title: string
  img?: string
  description
}

const Wrapper = styled('div')(({ theme }: { theme?: Theme }) => ({
  boxSizing: 'border-box',
  background: `${theme.palette.neutral.white[0]}`,
  border: `1px solid ${theme.palette.grey[2]}`,
  borderRadius: '4px',
  width: 'max-content',
  height: '64px',
}))

const ImgWrapper = styled.div<StyledProps>`
  width: 44px;
  height: 44px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.palette.grey[2]};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  border-radius: 4px;
`

export const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
`

export const Title = styled('p')<StyledProps>`
  flex: 1;
  color: ${({ theme }) => theme.palette.neutral.black};
  font-size: ${({ theme }) => theme.typography.m.regular.fontSize};
  margin-left: 6px;
  margin-right: 10px;
`

export const Description = styled('p')<StyledProps>`
  color: ${({ theme }) => theme.palette.grey[5]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  overflow: hidden;
  height: 36px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const InfoIcon = styled(IconTooltip)`
  margin-top: -26px;
  margin-right: 8px;
  &:focus,
  &:visited,
  &:active,
  &:hover {
    color: ${palette.vivid.brand};
  }
`

const ConnectionPaymentMethodCard = ({
  title,
  img,
  description,
}: ConnectionItemProps) => {
  return (
    <Wrapper>
      <HeaderStyled>
        <ImgWrapper>
          <img src={img} width={21} />
        </ImgWrapper>
        <Title>{title}</Title>
        {description && (
          <InfoIcon
            tooltip={{ title: description, children: <></> }}
            name="Info"
          />
        )}
      </HeaderStyled>
    </Wrapper>
  )
}

export default ConnectionPaymentMethodCard
